angular.module('app.factories').factory('interestsListFilterFactory', ($translate, $state, $log, listFilter) => {
    const interestsListFilter = listFilter;

    interestsListFilter
        .setAttributes({
            name: 'interestsListFilter',
            providers: ['filterAreasOptions', 'usersOptions', 'interestStatusOptions', 'lossOptions', 'clientOptionsForInterestFilter'],
        })
        .setFields({
            filter: {
                type: 'text',
                class: 'uk-width-medium-6-10',
                label: $translate.instant('search'),
                default: '',
            },
            search_in: {
                type: 'checkbox-list',
                class: 'uk-width-medium-4-10',
                label: $translate.instant('search_in'),
                names: [
                    { name: 'name', label: $translate.instant('interests.name') },
                    { name: 'client.name', label: $translate.instant('interests.client_id') },
                    { name: 'description', label: $translate.instant('interests.description') },
                    { name: 'notes', label: $translate.instant('interests.notes') },
                ],
                default: { name: true },
            },

            area: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-10-10',
                label: $translate.instant('areas'),
                default: '',
                optionsProvider: 'filterAreasOptions',
                options: [],
            },

            date_from: {
                type: 'date',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('filter.date_from'),
            },
            date_to: {
                type: 'date',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('filter.date_to'),
            },

            author_id: {
                type: 'multiuserlist',
                operator: 'in',
                class: 'uk-width-medium-3-10',
                label: $translate.instant('interests.author_id'),
                optionsProvider: 'usersOptions',
                options: [],
                default: '',
            },
            manager_id: {
                type: 'multiuserlist',
                operator: 'in',
                class: 'uk-width-medium-3-10',
                label: $translate.instant('interests.manager_id'),
                optionsProvider: 'usersOptions',
                options: [],
                default: '',
            },
            owner_id: {
                type: 'multiuserlist',
                operator: 'in',
                class: 'uk-width-medium-4-10',
                label: $translate.instant('interests.owner_id'),
                optionsProvider: 'usersOptions',
                options: [],
                default: '',
            },

            status_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-3-10',
                label: $translate.instant('interests.status_id'),
                optionsProvider: 'interestStatusOptions',
                options: [],
                default: '',
            },
            loss_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-3-10',
                label: $translate.instant('interests.loss_id'),
                optionsProvider: 'lossOptions',
                options: [],
                default: '',
            },
            client_id: {
                type: 'clientslist',
                class: 'uk-width-medium-4-10',
                label: $translate.instant('projects.client_id'),
                optionsProvider: 'clientOptionsForInterestFilter',
                options: [],
                default: '',
            },
        })
        .onRefresh(() => {
            const filterParams = interestsListFilter.getValues(true);
            interestsListFilter.updateClientsOptions('client_id');
            $log.debug('--> apply filter', filterParams);
            $state.applyFilter(filterParams);
        })
        .ready();

    return interestsListFilter;
});
